import { useContext } from 'react';

import { FunctionalitiesContext } from '../contexts';
import { FunctionalitiesContextProps } from './../contexts/types';
export function useFunctions(): FunctionalitiesContextProps {
    return useContext(FunctionalitiesContext);
}
